<template>
  <div class="tabs-pane" :class="classes" v-if="active">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: "bf-tabs-pane",
    inject: ['eventBus'],
    props:{
      name: {
        type: String | Number,
        required: true
      }
    },
    data(){
      return{
        active: false
      }
    },
    computed:{
      classes(){
        return {
          active: this.active
        }
      }
    },
    created(){
      this.eventBus.$on('update:selected', (name) => {
        this.active = name === this.name;
      })
    }
  }
</script>
<style scoped lang="scss">
  .tabs-pane {
    padding: 1em;
    &.active{
    }
  }
</style>



// WEBPACK FOOTER //
// src/packages/tabs/bf-tabs-pane/bf-tabs-pane.vue